module.exports = __webpack_public_path__ + "static/media/d.ec67d7cb.png";